import { createSlice } from '@reduxjs/toolkit';
import { dashboardInitialState } from '../initialStates/dashboard';

const setRecentEPR = (state, action) => {
  state.EPR = action.payload;
};

const setEPRTargets = (state, action) => {
  state.EPRTargets = action.payload;
};

const setRecentPPR = (state, action) => {
  state.PPR = action.payload;
};

const setNBJobs = (state, action) => {
  state.NBJobs = action.payload;
};

const setRefreshNBJobs = (state, action) => {
  state.refresh = action.payload;
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: dashboardInitialState,
  reducers: {
    setRecentEPR,
    setEPRTargets,
    setRecentPPR,
    setNBJobs,
    setRefreshNBJobs,
  },
});

export const dashboardActions = dashboardSlice.actions;

export default dashboardSlice.reducer;
